module.exports = __webpack_public_path__ + "img/itx-text-h4.c5a64aec.svg";